import { FC, ReactNode } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../helpers'

type Props = { children: ReactNode }

/**
 * The assistant's row: orb, name, and whatever the caller puts in the body.
 *
 * Extracted because the persisted path and the live-streaming path were
 * near-copies of this markup, and they drifted — the live one grew an empty-text
 * guard the persisted one never got, and the live one rendered its loading
 * indicator as a SECOND row, so a streaming answer showed as two AI messages.
 * One shell, one place to change.
 */
const AssistantRow: FC<Props> = ({ children }) => {
  const intl = useIntl()
  return (
    <div className='lum-row'>
      {/*
        Decorative: the avatar sits directly beside the `Ai` label, so a
        non-empty `alt` has a screen reader announce the speaker twice.
      */}
      <div className='lum-orb'>
        <img alt='' src={toAbsoluteUrl('ai.webp')} />
      </div>
      <div className='lum-msg-ai'>
        <div className='lum-name'>{intl.formatMessage({ id: 'Ai' })}</div>
        {children}
      </div>
    </div>
  )
}

export default AssistantRow
